import { productAdapter, MyOrganizationState, ProductState } from "@organizations/models";
import { selectMyOrganizationsState, productsReducer } from "@organizations/store/reducers";
import { createSelector } from "@ngrx/store";

const { selectAll } = productAdapter.getSelectors();

export const selectProductsState = createSelector(
  selectMyOrganizationsState,
  (state: MyOrganizationState) => state.products as ProductState
);

export const selectProducts = createSelector(selectProductsState, selectAll);

export const selectProductsLoading = createSelector(
  selectProductsState,
  productsReducer.getProductsLoading
);

export const selectProductsLoaded = createSelector(
  selectProductsState,
  productsReducer.getProductsLoaded
);
